// Example: Dashboard.jsx
import React from "react";
const NotFound = () => {
  return <div className="p-8 text-xl">Not Found page</div>;
};
export default NotFound;
